import React from "react";
import "../../styles/3-About/About.css";
import useLanguageContext from "../../hooks/useLanguageContext";
import Anselmo2 from "../../assets/images/anselmo-2.jpg";

const About = () => {
  const languageState = useLanguageContext();

  return (
    <section id="about">
      <div className="about__image">
        <img src={Anselmo2} alt="Anselmo Del hoyo" />
      </div>
      <article className="about__content">
        {languageState ? (
          <p>
            Hello, welcome to my portfolio, here I will be telling you a bit
            about who I am, my skills as a developer, and I will show you some
            of the projects that I have created so far in my path as a
            developer.
            <br />
            <br />
            My name is <span>Anselmo Del Hoyo</span>, I'm a Venezuelan, 
            front-end web developer who loves technology, with soft
            skills such as organization, adaptability, teamwork and
            self-learning. Currently I'm in constant study to master the
            different and most important technologies in this field of web
            programming.
          </p>
        ) : (
          <p>
            Hola, bienvenido a mi portafolio, aquí te estaré contando un poco
            sobre quién soy, mis habilidades como desarrollador, y te mostraré
            algunos de los proyectos que he creado hasta ahora en mi camino como
            desarrollador.
            <br />
            <br />
            Mi nombre es <span>Anselmo Del Hoyo</span>, soy un desarrollador web
            orientado al front-end, un venezolano amante de la tecnología, con
            habilidades blandas como la organización, la adaptabilidad, el
            trabajo en equipo y el autoaprendizaje. Actualmente estoy en
            constante estudio para dominar las diferentes y más importantes
            tecnologías en este campo de la programación web.
          </p>
        )}
      </article>
    </section>
  );
};

export default About;
